.message {
    padding: 0.5rem;
    margin: 0;
    border-radius: 0.5rem;
    border: 1px solid color-mix(in srgb, var(--message-bg), black 10%);
    background: var(--message-bg);
    color: var(--message-color);
}